import {EventWizardCoverMenuOpener} from '@Components/event-wizard/event-wizard-image-video/event-wizard-image-video.types';
import {EventsChangeCoverGA4Source} from '@Libraries/ga-events';

/** The tile is the cover's thumbnail itself, square and as tall as the Styles tile beside it. */
export const COVER_TILE_SIZE = 84;

export enum CoverTileMenuItemId {
  EDIT_DESIGN = 'edit-design',
  AI_DESIGNS = 'ai-designs',
  MY_DESIGNS = 'my-designs',
  UPLOADS = 'uploads',
  REMOVE = 'remove',
}

export const COVER_MENU_OPENER_GA4_SOURCES: Record<EventWizardCoverMenuOpener, EventsChangeCoverGA4Source> = {
  [EventWizardCoverMenuOpener.TILE]: EventsChangeCoverGA4Source.TILE,
  [EventWizardCoverMenuOpener.PREVIEW]: EventsChangeCoverGA4Source.PREVIEW,
};
